interface StepHeaderProps {
  step: {
    name: string;
    longDescription?: string;
    hideTitle?: boolean;
  };
}

export function StepHeader({ step }: StepHeaderProps) {
  if (!step || step.hideTitle) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <span className="text-lg font-semibold">{step.name}</span>
      {step.longDescription && (
        <span className="text-sm text-gray-500">{step.longDescription}</span>
      )}
    </div>
  );
}
